<template>
    <div class="form-group col-12 row">
        <div class="col-5">
            <v-select v-model="activeGroup" :options="groups" label="name" />
        </div>

        <div v-if="activeGroup" class="col-5">
            <v-select
                v-model="activeAttribute"
                :options="attributes"
                label="value"
            />
        </div>

        <div v-if="activeAttribute" class="col-2 d-flex justify-content-center">
            <button class="btn btn-success" @click="addAttribute">
                <i class="fas fa-plus" /> Add
            </button>
        </div>

        <div class="col-12 mt-3">
            <attribute-badge
                v-for="(attribute, index) in selectedAttributes"
                :key="attribute.id"
                :attribute="attribute"
                removable
                @remove="removeAttribute(index)"
            />
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import AttributeBadge from '@/components/attributes/Badge';

export default {
    components: {
        AttributeBadge
    },

    data() {
        return {
            selectedAttributes: [],
            groups: [],
            activeGroup: null,
            attributes: [],
            activeAttribute: null
        };
    },

    watch: {
        activeGroup(val) {
            if (val) {
                this.fetchAttributes();
            }
        }
    },

    async created() {
        try {
            this.groups = await this.getAttributeGroups();
        } catch (err) {
            console.error(err);

            this.$toasterError();
        }
    },

    methods: {
        ...mapActions({
            getAttributeGroups: 'attributeGroups/index',
            getAttributes: 'attributes/index'
        }),

        async fetchAttributes() {
            try {
                this.activeAttribute = null;
                this.attributes = await this.getAttributes(this.activeGroup.id);
            } catch (err) {
                console.error(err);

                this.$toasterError();
            }
        },

        addAttribute() {
            const isGroupAdded = this.selectedAttributes.some(
                attribute =>
                    attribute.attributeGroupId ===
                    this.activeAttribute.attributeGroupId
            );

            if (isGroupAdded) {
                return this.$toaster(
                    'Attribute from this group has been already added!',
                    {
                        title: 'Warning!',
                        variant: 'warning'
                    }
                );
            }

            this.selectedAttributes.push({
                ...this.activeAttribute,
                group: { ...this.activeGroup }
            });
            this.activeGroup = null;
            this.activeAttribute = null;

            this.emitChange();
        },

        removeAttribute(index) {
            this.selectedAttributes.splice(index, 1);
            this.emitChange();
        },

        emitChange() {
            this.$emit('change', this.selectedAttributes);
        }
    }
};
</script>
